const account = 'mdi-account-plus-outline';
const accountSettings = 'mdi-account-settings-outline';
const address = 'mdi-map-marker-outline';
const arrowLeft = 'mdi-arrow-left-bold';
const arrowRight = 'mdi-arrow-right-bold';
const chevronLeft = 'mdi-chevron-left';
const chevronRight = 'mdi-chevron-right';
const bank = 'mdi-bank';
const box = 'mdi-inbox-multiple';
const calendar = 'mdi-calendar-month-outline';
const calendarEdit = 'mdi-calendar-edit';
const cancel = 'mdi-cancel';
const cellPhone = 'mdi-cellphone';
const chart = 'mdi-chart-box-outline';
const check = 'mdi-check-bold';
const clipboardArrowUpOutline = 'mdi-clipboard-arrow-up-outline';
const clipboardArrowDownOutline = 'mdi-clipboard-arrow-down-outline';
const clipboardPlusOutline = 'mdi-clipboard-plus-outline';
const clipboardMinusOutline = 'mdi-clipboard-minus-outline';
const clipboardFlowOutline = 'mdi-clipboard-flow-outline';
const close = 'mdi-close';
const copy = 'mdi-content-copy';
const databaseSearch = 'mdi-database-search';
const dataRegisters = 'mdi-clipboard-text-outline';
const destroy = 'mdi-delete';
const domain = 'mdi-domain';
const dotsVertical = 'mdi-dots-vertical';
const download = 'mdi-download-box-outline';
const edit = 'mdi-pencil';
const email = 'mdi-email-outline';
const facebook = 'mdi-facebook';
const google = 'mdi-google-plus';
const filter = 'mdi-filter-menu-outline';
const financial = 'mdi-cash-register';
const home = 'mdi-home-alert-outline';
const industry = 'mdi-factory';
const list = 'mdi-format-list-bulleted-type';
const lockOutline = 'mdi-lock-outline'; 
const logout = 'mdi-logout';
const menuDown = 'mdi-menu-down';
const menuUp = 'mdi-menu-up';
const money = 'mdi-currency-usd';
const note = 'mdi-file-send-outline'; 
const noteMultiple = 'mdi-note-multiple'; 
const numeric = 'mdi-numeric';
const phone = 'mdi-phone';
const plus = 'mdi-plus';
const plusOutline = 'mdi-plus-circle-outline';
const printer = 'mdi-printer';
const printerPos = 'mdi-printer-pos';
const refresh = 'mdi-refresh'; 
const sale = 'mdi-point-of-sale';
const save = 'mdi-content-save';
const security = 'mdi-shield-lock';
const search = 'mdi-magnify';
const origin = 'mdi-share-all';
const text = 'mdi-format-text-rotation-none';
const tune = 'mdi-tune-vertical-variant';
const users = 'mdi-account-settings';
const view = 'mdi-eye';
const web = 'mdi-web';

export {
  account,
  accountSettings,
  address,
  arrowLeft,
  arrowRight,
  bank,
  box,
  calendar,
  calendarEdit,
  cancel,
  cellPhone,
  chart,
  check,
  chevronLeft,
  chevronRight,
  clipboardArrowUpOutline,
  clipboardArrowDownOutline,
  clipboardPlusOutline,
  clipboardMinusOutline,
  clipboardFlowOutline,
  close,
  copy,
  databaseSearch,
  dataRegisters,
  destroy,
  domain,
  dotsVertical,
  download,
  edit,
  email,
  facebook,
  google,
  filter,
  financial,
  home,
  industry,
  list,
  lockOutline,
  logout,
  phone,
  plus,
  plusOutline,
  menuDown,
  menuUp,
  money,
  note,
  noteMultiple,
  numeric,
  printer,
  printerPos,
  refresh,
  sale,
  save,
  security,
  search,
  origin,
  text,
  tune,
  users,
  view,
  web,
};